const cssUrl = `${import.meta.env.VITE_CDN_ROOT}${import.meta.env.VITE_ASCEND_AWESOME_VERSION}/css/trustage-aa--wc.css`
const t = document.createElement('template')
t.innerHTML = `
<link href="${cssUrl}" rel="stylesheet" />
<style>

  .table-responsive {
    flex: 1;
    overflow-x: auto;
  }

  table {
    table-layout: fixed;
    border-collapse: collapse;
    background: var(--wa-color-neutral-100, #FFF);
  }

  th, td {
    width: auto;
    padding: var(--wa-spacing-m, 16px);
    align-items: center;
    gap: 8px;
    word-wrap: break-word;
  }

  th {  
    flex-shrink: 0;
    border-bottom: var(--wa-border-width-s, 1px) solid var(--wa-color-neutral-80, #E4E4E7);

    overflow: hidden;
    color: var(--wa-color-neutral-10, #171717);
    text-overflow: ellipsis;
    text-align: left;
    
    font-family: var(--wa-font-family-sul-sans);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 18px */
  }

  td {      
    border-bottom: var(--wa-border-width-s, 1px) solid var(--wa-color-neutral-80, #E4E4E7);

    overflow: hidden;
    color: var(--wa-color-neutral-10, #171717);
    text-overflow: ellipsis;
    white-space: nowrap;

    /* Sul Sans UI/Regular - Small */
    font-family: var(--wa-font-family-sul-sans);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
  }

  .header-icon {
    display: flex;
    width: var(--wa-font-size-m, 16px);
    height: 16px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    aspect-ratio: 1/1;
  }

  tr:hover {
    background-color: var(--wa-color-neutral-95, #F9F9F9);
  }

  .table-spacing-condensed tbody tr .cell-button-condensed {
    padding: 2px;
  }

  .table-spacing-condensed tbody tr td {
    padding: var(--wa-spacing-s, 8px);
  }

  .table-spacing-condensed thead tr th {
    padding: var(--wa-spacing-s, 8px);
  }

  .table-striped tbody tr:nth-child(even) td {
    background-color: var(--wa-color-neutral-90, #fafafa);
  }

  .table-striped thead tr th {
    background-color: var(--wa-color-neutral-90, #fafafa);
  }

  .filled {  
    background: var(--wa-color-neutral-95, #F9F9F9);
  }

  .highlighted {
    background: var(--wa-color-primary-95, #EFF6FF);
  }

  .cell-text {
    
  }
  .cell-subtext {
    color: var(--wa-color-neutral-50, #737373);
    font-size: 12px;
    line-height: 18px;
  }

 .pagination {

 }
 .page-list {
   display: flex;
   list-style: none;
   padding: 0;
   margin: 0 1rem;
 }
 .page-list li {
   margin: 0 0.5rem;
 }
 .pagination-wrapper {   
   justify-content: left;
   align-items: center;
   margin: 1rem 0;
 }

 .hide {
   display: none;
}

 .ts-stack {
   display: flex;
   flex-direction: column;
   justify-content: flex-start
 }

 .ts-split {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
</style>
`
const TemplateDataTableStyles = t
export { TemplateDataTableStyles }
